import { useState } from "react";
import type { ISize, TSize } from "~/components/ui/VariantPicker";
import { useDatasource } from "~/lib/storyblok/useDatasource";

export const useSizes = (sizes?: ISize[]): [TSize[], TSize | undefined, () => void] => {
	// Track selection by the size's own key rather than object identity - the
	// `sizes` array is rebuilt with new object references on every render, so
	// comparing objects directly would never match after the first render.
	const [selectedSizeKey, setSelectedSizeKey] = useState<string | null>(
		sizes?.length === 1 ? sizes[0].size : null,
	); // auto-select if only one size
	const getLabel = useDatasource("pdp-text");
	const selectSize = (size: ISize) => {
		setSelectedSizeKey(size.size);
	};

	const newSizes = sizes?.map((size) => {
		return {
			...size,
			selected: size.size === selectedSizeKey,
			select: () => selectSize(size),
			name: getLabel(size.name),
		};
	});

	const selected = newSizes?.find((size) => size.selected);

	const reset = () => {
		setSelectedSizeKey(sizes?.length === 1 ? sizes[0].size : null);
	};

	return [newSizes || [], selected, reset];
};
